/** @format */

import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { useGetUserResourceReferenceQuery } from "../../app/services/userResourceApi";
import { Markup } from "interweave";
import ResourcePageUI from "../resources/resourcePage/ResourcePageUI";
import { useLocale } from "../../i18n/hooks";
import ErrorPage from "../errorPage/ErrorPage";
import { Spinner } from "react-bootstrap";

const UserResourcePage: React.FC = () => {
  const { userResource, copy } = useParams();
  const locale = useLocale();

  const {
    data: userResourceRef,
    error: userResourceError,
    isFetching,
    isSuccess,
  } = useGetUserResourceReferenceQuery({
    code: userResource as string,
    locale: locale,
    copy: isNaN(Number(copy)) ? 0 : Number(copy),
  });

  const { t: _ } = useTranslation();

  return (
    <div>
      {isFetching ? (
        <div className="position-absolute top-50 start-50 translate-middle">
          <Spinner />
        </div>
      ) : isSuccess ? (
        <>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                <Link to="../" className="text-reset">
                  {_("Dashboard")}
                </Link>
              </li>
              {userResourceRef && (
                <>
                  <li className="breadcrumb-item active" aria-current="page">
                    <Markup content={userResourceRef.Object.title} />
                  </li>
                </>
              )}
            </ol>
          </nav>
          <ResourcePageUI resourceRef={userResourceRef} preview={false} />
        </>
      ) : (
        userResourceError && (
          <ErrorPage
            statusCode={
              "status" in userResourceError &&
              typeof userResourceError.status === "number"
                ? userResourceError.status
                : undefined
            }
            hiddenMessage={
              "data" in userResourceError &&
              typeof userResourceError.data === "string"
                ? userResourceError.data
                : undefined
            }
            actions={["report", "newResource"]}
          />
        )
      )}
    </div>
  );
};

export default UserResourcePage;
